<template>
  <v-sheet
    :color="color"
    :height="size"
    :width="size"
    class="d-flex"
    style="padding: 8px"
  >
    <img :src="hyperdriveLogo" alt="Hyperdrive logo" style="width: 100%" />
  </v-sheet>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useInternalUser } from '#root/lib/useInternalUser'
import hyperdriveLogo from '#root/assets/logos/hyperdrive.svg'

const { internalUser } = useInternalUser()
const color = ref('red')

withDefaults(
  defineProps<{
    size?: number
  }>(),
  {
    size: 68
  }
)

onMounted(() => {
  if (internalUser.value) color.value = 'blue'
})
</script>
